export interface UpdateUserPrinterDocument {
  userPrinterId: string;
  documentIds: string[];
}
